import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=24da8e98&"
import script from "./ProfileAvatar.vue?vue&type=script&lang=js&"
export * from "./ProfileAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports